const EDIT_APP_SPORTS_REVIEW_DRAFT_PREFIX = 'admin:appSportsReviewDraft:edit:'
export const NEW_APP_SPORTS_REVIEW_DRAFT_KEY = 'admin:appSportsReviewDraft:new'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue = 1) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// App 운동시설 리뷰 폼은 운영자가 다시 입력 비용이 큰 선택 시설과 리뷰 값만 sessionStorage에 남긴다.
export const createAppSportsReviewDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            sportsId: params.sportsId ?? null,
            thumbnail: normalizeTextValue(params.thumbnail),
            title: normalizeTextValue(params.title),
            address: normalizeTextValue(params.address),
            star: normalizeNumberValue(params.star, 1),
            content: normalizeTextValue(params.content),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 작성 흐름을 이어간다.
export const applyAppSportsReviewDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppSportsReviewDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            sportsId: draftParams.sportsId === undefined ? normalizedBaseDraft.params.sportsId : draftParams.sportsId,
            thumbnail: draftParams.thumbnail === undefined ? normalizedBaseDraft.params.thumbnail : normalizeTextValue(draftParams.thumbnail),
            title: draftParams.title === undefined ? normalizedBaseDraft.params.title : normalizeTextValue(draftParams.title),
            address: draftParams.address === undefined ? normalizedBaseDraft.params.address : normalizeTextValue(draftParams.address),
            star: draftParams.star === undefined
                ? normalizedBaseDraft.params.star
                : normalizeNumberValue(draftParams.star, normalizedBaseDraft.params.star),
            content: draftParams.content === undefined
                ? normalizedBaseDraft.params.content
                : normalizeTextValue(draftParams.content),
        }
    }
}

export const createEditAppSportsReviewDraftKey = (sportsReviewId) => `${EDIT_APP_SPORTS_REVIEW_DRAFT_PREFIX}${sportsReviewId}`

export const readAppSportsReviewDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppSportsReviewDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppSportsReviewDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
